<template>
  <div style="text-align: center">
    <span v-for="period in periods" :key="'ppstatuses-' + period.getId()">
      <a
        class="period-cell"
        @click.stop="showDialog(period.getId())"
        v-tooltip.top="
          $t('features.long_term.columns.promise_start_on', {
            date: period.getPeriodStartRaw(),
          }) +
          ' (' +
          $t('global.click_to_view') +
          ')'
        "
        style="display: inline-block"
      >
        <font-awesome-icon
          icon="file-contract"
          :style="{ color: period.getIconColor() }"
          style="height: 1.25rem"
        />

        <Dialog
          :visible="dialogIsOpen === period.getId()"
          @update:visible="dialogIsOpen = false"
          :key="'period-' + period.getId()"
          style="width: 50rem"
          :draggable="false"
          modal
        >
          <template #header>
            <long-term-period-title :period="period" />
          </template>

          <long-term-period :period="period" :company="company" />

          <template #footer>
            <Button
              :label="$t('global.ok')"
              @click="hideDialog()"
            />
          </template>
        </Dialog>
      </a>
    </span>
  </div>
</template>
<script lang="ts">
import _ from 'lodash';
import type { PropType } from 'vue';
import type { YieldPromiseStatusJson } from '@/data/plants/YieldPromiseStatusJson.ts';
import Company from '@/domain/model/business/Company';
import YieldPromiseStatus from '@/domain/model/business/YieldPromiseStatus.ts';
import LongTermPeriod from '@/presentation/components/long-term-period/LongTermPeriod.vue';
import LongTermPeriodTitle from '@/presentation/components/long-term-period/LongTermPeriodTitle.vue';
import PlantIssues from '@/presentation/components/status/icon/PlantIssues.vue';

export default {
  name: 'promise-period-cell',
  components: {
    LongTermPeriod,
    LongTermPeriodTitle,
    PlantIssues,
  },
  props: {
    company: { type: Company, required: true },
    promisePeriods: {
      type: Array as PropType<YieldPromiseStatusJson[]>,
      default: () => [],
    },
    periodsToShow: { type: String, required: true },
  },
  data() {
    return {
      dialogIsOpen: null,
    };
  },
  computed: {
    periods() {
      if (0 === this.promisePeriods.length) {
        return [];
      }
      const currentPJson = _.maxBy(
        this.promisePeriods,
        (pJson) => pJson.period_index,
      );

      if ('current' === this.periodsToShow) {
        return [new YieldPromiseStatus(currentPJson)];
      } else if ('previous' === this.periodsToShow) {
        return this.promisePeriods
          .filter((pJson) => pJson.period_index !== currentPJson.period_index)
          .map((period) => new YieldPromiseStatus(period));
      } else {
        return this.promisePeriods.map(
          (period) => new YieldPromiseStatus(period),
        );
      }
    },
  },
  methods: {
    showDialog(periodId) {
      this.dialogIsOpen = periodId;
    },
    hideDialog() {
      this.dialogIsOpen = false;
    },
  },
};
</script>

<style scoped>
.period-cell {
  padding: 2px;
  margin-left: 2px;
}
</style>
